import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-male-tai-chi-yoga-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga-pr&exp=web_transactions_with_auto_refund~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_transactions_with_auto_refund'),
			},
		},
	},
]

export default config
